import React from 'react';
import * as style from '../Hooks/style';

export const NavMenu = (
  {
  active1,
  active2,
  active3,
  active4,
  active5,
  }) => {
    return (
      <style.styledNav active={active5}>
        <style.styledNavSub active={active5}>&nbsp;</style.styledNavSub>
        <style.styledNavSub active={active4}>&nbsp;</style.styledNavSub>
        <style.styledNavSub active={active3}>&nbsp;</style.styledNavSub>
        <style.styledNavSub active={active2}>&nbsp;</style.styledNavSub>
        <style.styledNavSub active={active1}>&nbsp;</style.styledNavSub>
        <style.styledNavSubText active={active1}>Scroll for more</style.styledNavSubText>
      </style.styledNav>
    );
}
